<template>
	<div>

		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-9 col-md-7 col-lg-5 m-auto pt-5">
					<div class="card mt-5">
						<div class="card-header bg-white">
							<h3 class="text-center mb-0 text-secondary">
								{{$conf.logo}}
							</h3>
						</div>
						<div class="card-body">
							<!-- <el-form ref="ruleForm" :rules="rules" :model="form">
								<el-form-item prop="username">
									<el-input v-model="form.username" size="medium" placeholder="请输入用户名">
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="form.password" size="medium" type="password" placeholder="请输入密码">
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" size="medium" class="w-100" @click="submit" :loading="loading">
										{{loading? '登录中...' : '立即登录'}}
									</el-button>
								</el-form-item>
							</el-form> -->

							<el-form :model="Register" :rules="rules1" ref="RegisterForm" label-width="0" class="RegisterForm">
								<el-form-item prop="phone">
									<el-input v-model="Register.phone" maxlength="11" placeholder="请输入手机号"></el-input>
								</el-form-item>
								<el-form-item prop="reg" class="code">
									<el-input v-model="Register.sendcode" maxlength="6" placeholder="请输入验证码"></el-input>
									<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码
									</el-button>
									<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}
									</el-button>
								</el-form-item>

								<el-form-item>
									<el-button type="primary" @click="submitForm">提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	let ms = []
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				form: {
					username: "",
					password: ""
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: 'blur'
					}]
				},
				rules1: {
					phone: [{
						required: true,
						message: "请输入手机号",
						trigger: 'blur'
					}],
					reg: [{
						required: true,
						message: "请输入验证码",
						trigger: 'blur'
					}]
				},
				Register: {
					phone: '',
					sendcode: '',
				},
				disabled: false,
				time: 0,
				btntxt: "重新发送",
			}
		},
		computed: {
			...mapGetters([
				'adminIndex'
			])
		},
		methods: {
			//手机验证发送验证码
			sendcode() {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (this.Register.phone == '') {
					this.$message({
						message: '手机号不能为空',
						center: true
					})
					return
				}
				if (!reg.test(this.Register.phone)) {
					this.$message({
						message: '请输入正确的手机号',
						center: true
					})
					return
				} else {
					console.log(this.Register.phone);
					this.$message({
						message: '发送成功',
						type: 'success',
						center: true
					});
					this.time = 60;
					this.disabled = true;
					this.timer();
				}
			},
			//60S倒计时
			timer() {
				if (this.time > 0) {
					this.time--;
					this.btntxt = this.time + "s后重新获取";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "获取验证码";
					this.disabled = false;
				}
			},
			submitForm() {
				this.$refs.RegisterForm.validate((e) => {
					console.log(e)
				})
			},
			submit() {
				this.$refs.ruleForm.validate((e) => {
					if (!e) return;
					// 提交表单
					this.loading = true
					this.axios.post('/admin/login', this.form).then(res => {
						// 存储到vuex
						let data = res.data.data
						// console.log(JSON.stringify(data.tree))
						// 存储到本地存储
						this.$store.commit('login', data)
						// 存储权限规则
						if (data.role && data.role.rules) {
							window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules))
						}

						var tree = this.$conf.navBar
						// 生成后台菜单
						this.$store.commit('createNavBar', tree)
						// 成功提示
						this.$message('登录成功')
						this.loading = false
						// 跳转后台首页
						this.$router.push({
							name: this.adminIndex
						})
					}).catch(err => {
						this.loading = false
					})
				})
			}
		},
	}
</script>

<style>
</style>
